import { useNavigate } from "react-router-dom";
import { DateTime } from "luxon";
import IconChat from "../../components/icons/IconChat";
import IconSchema from "../../components/icons/IconSchema";
import { getParticipantInitials, getParticipantName } from "../../utils/participantDisplay";

export default function ConversationProgressRow({ progress }) {
    const navigate = useNavigate();
    const name = getParticipantName(progress);
    const conversation = progress.conversationId;

    return (
        <li className="conv-participant-row conv-progress-row">
            <span className="conv-participant-avatar">{getParticipantInitials(name)}</span>
            <span className="conv-participant-name">{name}</span>

            <span className="conv-progress-conversation">
                {conversation?.name || "—"}
                {conversation?.typeId ? <span className="conv-progress-type-badge">{conversation.typeId.name}</span> : ""}
            </span>

            <span className="conv-participant-date">
                {progress.dAdd ? DateTime.fromISO(progress.dAdd.replace(/\[.*\]/, ""), { setZone: true }).toFormat("dd.MM.yyyy HH:mm") : ""}
            </span>

            <span className={`conv-participant-status ${progress.isFinished === 1 ? "done" : "pending"}`}>
                {progress.isFinished === 1 ? "Завершено" : "В процесі"}
            </span>

            <div className="conv-progress-row-actions">
                <div className="conv-tile-action" title="Переглянути повідомлення" onClick={() => navigate("/messages/byconvprogress/" + progress.id)}>
                    <IconChat fillColor="icon-teel" style={{ width: 18, height: 18 }} />
                </div>
                {conversation?.id ? (
                    <div className="conv-tile-action" title="Відкрити конструктор" onClick={() => navigate("/conversations-creator-canvas/" + conversation.id)}>
                        <IconSchema fillColor="icon-orange" style={{ width: 18, height: 18 }} />
                    </div>
                ) : (
                    ""
                )}
            </div>
        </li>
    );
}
